// @flow

import React from 'react';
import { H2, H3, Body, BodySmall } from 'components/Text';
import type { AccordionBlockData } from 'api/cms';

const AccordionBlock = ({
  data: { sections, headline, subtitle }
}: {
  data: AccordionBlockData
}) => (
  <>
    {headline && <H2>{headline}</H2>}
    {subtitle && <Body dangerouslySetInnerHTML={{ __html: subtitle }} />}
    {sections.map((section, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <React.Fragment key={index}>
        <H3>{section.title}</H3>
        <BodySmall dangerouslySetInnerHTML={{ __html: section.content }} />
      </React.Fragment>
    ))}
  </>
);

export default AccordionBlock;
